import React, { useState } from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const styles = {
  tag: {
    display: 'inline-block',
    fontSize: '12px',
    fontWeight: 600,
    color: '#d6415c',
    background: '#fde5ea',
    padding: '3px 10px',
    borderRadius: '6px',
    marginBottom: '14px',
  },
  meta: {
    color: '#6b6b7d',
    fontSize: '14px',
    marginBottom: '28px',
  },
  coverWrap: {
    width: '100%',
    maxHeight: '520px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f6f6fb',
    borderRadius: '14px',
    overflow: 'hidden',
    marginBottom: '28px',
  },
  cover: {
    maxWidth: '100%',
    maxHeight: '520px',
    width: 'auto',
    height: 'auto',
    display: 'block',
  },
  content: {
    fontSize: '16px',
    lineHeight: 1.8,
    marginBottom: '36px',
  },
  galleryHeading: {
    fontSize: '20px',
    marginBottom: '16px',
  },
  galleryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: '14px',
  },
  galleryImg: {
    width: '100%',
    aspectRatio: '4 / 3',
    objectFit: 'cover',
    borderRadius: '10px',
    display: 'block',
    cursor: 'pointer',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(20, 20, 30, 0.9)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  overlayImg: {
    maxWidth: '90vw',
    maxHeight: '85vh',
    borderRadius: '8px',
    display: 'block',
  },
  closeBtn: {
    position: 'absolute',
    top: '20px',
    right: '30px',
    color: '#fff',
    fontSize: '32px',
    cursor: 'pointer',
    lineHeight: 1,
    background: 'none',
    border: 'none',
  },
  navBtn: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#fff',
    fontSize: '40px',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: '10px 16px',
    userSelect: 'none',
  },
  prevBtn: { left: '10px' },
  nextBtn: { right: '10px' },
};

const Story = ({ data }) => {
  const { title, date, location, category, image, gallery } = data.markdownRemark.frontmatter;
  const { html } = data.markdownRemark;
  const [openIndex, setOpenIndex] = useState(null);

  const close = () => setOpenIndex(null);
  const showPrev = (e) => {
    e.stopPropagation();
    setOpenIndex((i) => (i === 0 ? gallery.length - 1 : i - 1));
  };
  const showNext = (e) => {
    e.stopPropagation();
    setOpenIndex((i) => (i === gallery.length - 1 ? 0 : i + 1));
  };

  return (
    <Layout bodyClass="page-story-single">
      <SEO title={title} />
      <div className="container pb-6 pt-6 pt-md-10 pb-md-10">
        <div className="row justify-content-start">
          <div className="col-12 col-md-8">
            {category && <span style={styles.tag}>{category}</span>}
            <h1 className="title">{title}</h1>
            <p style={styles.meta}>
              {date} {location && `· ${location}`}
            </p>

            {image && (
              <div style={styles.coverWrap}>
                <img alt={title} src={image} style={styles.cover} />
              </div>
            )}

            <div style={styles.content} dangerouslySetInnerHTML={{ __html: html }} />

            {gallery && gallery.length > 0 && (
              <div>
                <h3 style={styles.galleryHeading}>More from this event</h3>
                <div style={styles.galleryGrid}>
                  {gallery.map((photo, index) => (
                    <img
                      key={index}
                      alt={`${title} photo ${index + 1}`}
                      src={photo}
                      style={styles.galleryImg}
                      onClick={() => setOpenIndex(index)}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {openIndex !== null && gallery && (
        <div style={styles.overlay} onClick={close}>
          <button style={styles.closeBtn} onClick={close}>×</button>
          {gallery.length > 1 && (
            <button style={{ ...styles.navBtn, ...styles.prevBtn }} onClick={showPrev}>‹</button>
          )}
          <img
            src={gallery[openIndex]}
            alt={`${title} photo ${openIndex + 1}`}
            style={styles.overlayImg}
            onClick={(e) => e.stopPropagation()}
          />
          {gallery.length > 1 && (
            <button style={{ ...styles.navBtn, ...styles.nextBtn }} onClick={showNext}>›</button>
          )}
        </div>
      )}
    </Layout>
  );
};

export const query = graphql`
  query($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        date(formatString: "DD MMMM YYYY")
        location
        category
        image
        gallery
      }
      fields {
        slug
      }
      html
    }
  }
`;

export default Story;